import React from "react";
import {graphql, Link, useStaticQuery} from "gatsby";
import styles from "./NotFoundPage.module.scss";
import Typography from "@material-ui/core/Typography";

const NotFoundPage = () => {
    const { bg } = useStaticQuery(graphql`
        query {
            bg: allFile(filter: { sourceInstanceName: { eq: "not-found" } }) {
                nodes {
                    name
                    publicURL
                }
            }
        }
    `);

    return (
        <div className={styles['not-found']}>
            <Typography variant="h1" className={styles['title-mobile']} align={'center'} color={'secondary'}>Page not found</Typography>
            <div className={styles['not-found__text']}>
                <Typography variant="h1">Page not found</Typography>
                <Typography variant={'h3'}>
                    The page you are looking for may <br/> be removed or non-existent
                </Typography>

                <Link to={'/'}>go to homepage</Link>
                <Link to={'/contact-us'}>
                    contact us
                </Link>
            </div>
            <img src={bg.nodes[0].publicURL} alt="" />
        </div>
    );

}

export default NotFoundPage
